import news from '../../api/news/'

const state = {
    list: jsonData.news,
    news_: null,
    page: 1,
}

// getters
const getters = {
    news(state) {
        return state.list || []
    },
    _loadedNews: (state, getters) => {
        //debugger
        return getters.news.filter((news_) => news_._loaded)
    },
}

// actions
const actions = {
    get({commit}, opts) {
        return news.get(opts)
            .then(res => {
                commit('setNews', res.data)
            })
    },
    getPost({commit, state}, opts) {
        // try to find
        if (Array.isArray(state.list)) {
            let news_ = state.list.find(news_ => news_.slug === opts.slug)

            if (news_) {
                commit('setNews_', news_)
                return
            }
        }

        // fetch api
        return news.get(opts)
            .then(res => {
                commit('setNews_', res.data[0])
            })

    },
    setNews_({commit}, news_) {
        commit('setNews_', news_)
    },

    setPage({commit}, page) {
        commit('setPage', page)
    },
}

// mutations
const mutations = {
    setNews(state, news) {
        state.list = state.list || []
        state.list = state.list.concat(news)
    },
    setNews_(state, news_) {
        //debugger
        state.news_ = news_
    },
    setPage(state, page) {
        state.page = page
    },
    setLoadedNews(state, news_) {
        //debugger
        Vue.set(news_, '_loaded', true)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
